import { AssetStatusCategories } from "src/app/asset/models/asset.model";

export class AssetModel {
    id: string;
    propertyId: string;
    name: string;
    model: string;
    barcode: string;
    description: string;
    make: string;
    dateOfPurchase: string | null;
    usefulLife: number;
    maintenanceCycle: number;
    attachments: AssetAttachment[];
    note: string;
    isPrivate: boolean;
    isAiGenarated: boolean;
    isVacantProperty: boolean;
    areaLevel: string;
    cost: number;
    status: AssetStatusCategories;
    isOnceSendToTenantAsset: boolean;
}
export class AssetImResult {
    id: string;
    propertyId: string;
    name: string;
    model: string;
    barcode: string;
    description: string;
    make: string;
    dateOfPurchase: string | null;
    usefulLife: number;
    maintenanceCycle: number;
    attachments: AssetAttachment[];
    note: string;
    isPrivate: boolean;
    isAiGenarated: boolean;
    isVacantProperty: boolean;
    areaLevel: string;
    cost: number;
    isPendingApproval: boolean;
}

export class AssetAttachment {
    id: string;
    name: string;
    blobUrl?: string;
    extension?: string;
    attachmentType?: number;
}

export class AssetWithDuplicatesModel {
    asset : AssetModel;
    duplicatedAssets : string[];
}

export class ScannedAssetDetailModel {
    propertyId: string;
    assets : AssetsModel[]=[];
    isVacantProperty: boolean;
    tenantId: string;
}
export class AssetsModel {
    name: string;
    attachment: AssetAttachment;
}
export class AssetForRecommendationModel {
    assetId: string;
    propertyId: string;
    name: string;
    model: string;
    barcode: string;
    description: string;
    dateofpurchase: string | null;
    usefullifeperiod: number;
    maintenanceCycle: number;
    attachments: AssetAttachment[];
    note: string;
    isPrivate: boolean;
    isAiGenarated: boolean;
    isVacantProperty: boolean;
    areaLevel: string;
    address: string;
    manufacture: string;
    isRelatedToJob: boolean;
}
export class AssetSnoozeModel {
    assetId: string;
    timePeriod: number;
}
